module.exports = __webpack_public_path__ + "img/dropbox-square.4e1b2c86.svg";